import { faEnvelope, faHome, faIdCard, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropsTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";

import reducer from "../reducer";

export default function Navbar(props) {
  const [state, dispatch] = React.useReducer(reducer, {
    QTY_MESSAGE: 0,
    QTY_INTERVIEW: 0,
    QTY_SYSTEM: 0,
    QTY_NOTICE: 0,
  });
  const auth = useSelector((state) => state.auth);
  const { category } = props;

  React.useEffect(() => {
    if (0 < auth.id) {
      let url = [
        "/api/miscellaneous/message",
        "?option=group-ref_id-by-ref_id2-tag-category-status",
        `&ref_id2=${auth.id}`,
        "&tag=企业用户",
        "&category=咨询企业",
        "&status=未读",
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          dispatch({
            type: "set",
            payload: {
              key: "QTY_MESSAGE",
              value: state.QTY_MESSAGE + data.length,
            },
          });
        });
      url = [
        "/api/biz/interview/statistic",
        "?option=qty-by-ref_id-status",
        `&ref_id=${auth.id}`,
        "&status=未读",
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          dispatch({
            type: "set",
            payload: {
              key: "QTY_INTERVIEW",
              value: state.QTY_INTERVIEW + data.qty,
            },
          });
        });
      url = [
        "/api/miscellaneous/message/statistic",
        "?option=qty-by-ref_id2-category-tag-status",
        `&ref_id2=${auth.id}`,
        "&category=系统消息",
        "&tag=个人用户",
        "&status=未读",
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          dispatch({
            type: "set",
            payload: { key: "QTY_SYSTEM", value: state.QTY_SYSTEM + data.qty },
          });
        });
      url = ["/api/bulletin", "?option=bulletin-by-tag", "&tag=个人用户"];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          try {
            const readIds = JSON.parse(localStorage.getItem("sysMessage_read_ids") || "[]");
            const unreadCount = data.filter((item) => !readIds.includes(item.id)).length;
            dispatch({
              type: "set",
              payload: {
                key: "QTY_NOTICE",
                value: state.QTY_NOTICE + unreadCount,
              },
            });
          } catch {
            dispatch({
              type: "set",
              payload: {
                key: "QTY_NOTICE",
                value: state.QTY_NOTICE + data.length,
              },
            });
          }
        });
    }
  }, []);

  return (
    <>
      <div style={{ height: 60 }} />
      <ul
        className="nav bg-white nav-light fixed-bottom border-top text-center nav-bottom justify-content-center"
        style={{ fontSize: 11 }}
      >
        <li className="nav-item">
          <a
            href="#/"
            className={`nav-link ${category === "首页" ? "text-primary" : "text-muted"} `}
          >
            <FontAwesomeIcon icon={faHome} size="2x" fixedWidth />
            <br />
            首页
          </a>
        </li>

        <li className="nav-item">
          <a
            href="#岗位"
            className={`nav-link ${category === "岗位" ? "text-primary" : "text-muted"} `}
          >
            <FontAwesomeIcon icon={faIdCard} size="2x" fixedWidth />
            <br />
            岗位
          </a>
        </li>

        <li className="nav-item">
          <a
            href="#校园招聘"
            className={`nav-link ${category === "校园招聘" ? "text-primary" : "text-muted"} `}
          >
            <img style={{ width: 35, height: 25 }} src="lib/img/icon.png" alt="" />
            <br />
            校园招聘
          </a>
        </li>
        <li className="nav-item">
          <a
            href="#消息"
            className={`nav-link ${category === "消息" ? "text-primary" : "text-muted"} `}
          >
            <span className={`${state.QTY_MESSAGE > 0 ? "message-point" : ""}`}>
              <FontAwesomeIcon icon={faEnvelope} size="2x" fixedWidth />
            </span>
            <br />
            消息
          </a>
        </li>
        <li className="nav-item">
          <a
            href="#我的"
            className={`nav-link ${category === "我的" ? "text-primary" : "text-muted"} `}
          >
            <span
              className={`${state.QTY_INTERVIEW + state.QTY_SYSTEM + state.QTY_NOTICE > 0 ? "message-point" : ""}`}
            >
              <FontAwesomeIcon icon={faUser} size="2x" fixedWidth />
            </span>
            <br />
            我的
          </a>
        </li>
      </ul>
    </>
  );
}

Navbar.propTypes = {
  category: PropsTypes.string.isRequired,
  totalFlg: PropsTypes.bool,
};

Navbar.defaultProps = {
  totalFlg: undefined,
};
